import React from 'react';
import { BaselineComparisonProps } from './types';
import BaselineComparisonControls from './BaselineComparisonControls';
import BaselineComparisonEmptyState from './BaselineComparisonEmptyState';
import BaselineComparisonLegend from './BaselineComparisonLegend';
import BaselineComparisonHeatmapTable from './BaselineComparisonHeatmapTable';

interface BaselineComparisonViewProps extends BaselineComparisonProps {
  chartData?: Array<{ time: string; [key: string]: any }>;
}

const BaselineComparisonView: React.FC<BaselineComparisonViewProps> = ({
  comparisonData,
  timesteps,
  baselineLabel,
  availableBaselines,
  aggregationMode,
  alignmentMode,
  onBaselineChange,
  onAggregationModeChange,
  onAlignmentModeChange,
  onCellHover,
  onCellLeave,
  chartData = [],
  statisticalContext,
}) => {
  if (comparisonData.length === 0) {
    return <BaselineComparisonEmptyState />;
  }

  return (
    <div className="p-2">
      <div className="space-y-2">
        {/* Controls */}
        <BaselineComparisonControls
          baselineLabel={baselineLabel}
          availableBaselines={availableBaselines}
          aggregationMode={aggregationMode}
          alignmentMode={alignmentMode}
          onBaselineChange={onBaselineChange}
          onAggregationModeChange={onAggregationModeChange}
          onAlignmentModeChange={onAlignmentModeChange}
        />

        {/* Heatmap Table */}
        <BaselineComparisonHeatmapTable
          comparisonData={comparisonData}
          timesteps={timesteps}
          baselineLabel={baselineLabel}
          aggregationMode={aggregationMode}
          alignmentMode={alignmentMode}
          chartData={chartData}
          onCellHover={onCellHover}
          onCellLeave={onCellLeave}
          statisticalContext={statisticalContext}
        />

        {/* Legend */}
        <BaselineComparisonLegend />
      </div>
    </div>
  );
};

export default BaselineComparisonView;
